import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectCurrentLanguage } from '../../../../features/langSlice';

/* "*word*" → coloured italic emphasis, "\n" → line break. Same markup as the sandbox copy. */
export const rich = (text) =>
  String(text)
    .split('\n')
    .map((line, i) => (
      <React.Fragment key={i}>
        {i > 0 && <br />}
        {line.split(/\*([^*]+)\*/).map((part, j) => (j % 2 ? <em key={j}>{part}</em> : part))}
      </React.Fragment>
    ));

export const stripMarkup = (text) => String(text).replace(/\*/g, '').replace(/\n/g, ' ');

/* Copy lookup for the carousel slides: keys are PC_* in assets/i18n/{de,en,fr}.json.
   `variant(key, suffix)` returns key_suffix when it exists (plan / purpose overrides), otherwise the base key. */
const useCopy = () => {
  const { t, i18n } = useTranslation();
  const lang = useSelector(selectCurrentLanguage) || 'de';
  const variantKey = (key, suffix) => (suffix && i18n.exists(`${key}_${suffix}`) ? `${key}_${suffix}` : key);
  return {
    lang,
    text: (key, vars) => t(key, vars),
    rich: (key, vars) => rich(t(key, vars)),
    variantText: (key, suffix, vars) => t(variantKey(key, suffix), vars),
    variantRich: (key, suffix, vars) => rich(t(variantKey(key, suffix), vars)),
  };
};

export default useCopy;
